const COLORS = {
  ready: { bg: "rgba(22,163,74,0.10)", text: "#15803d", border: "rgba(22,163,74,0.30)", label: "READY" },
  hold: { bg: "rgba(217,119,6,0.10)", text: "#b45309", border: "rgba(217,119,6,0.30)", label: "HOLD" },
  critical: { bg: "rgba(220,38,38,0.10)", text: "#b91c1c", border: "rgba(220,38,38,0.30)", label: "CRITICAL" },
};

export default function StatusBadge({ status = "ready", className = "", dot = true }) {
  const c = COLORS[status] || COLORS.ready;
  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 text-[10px] font-bold tracking-[0.15em] rounded-full border ${className}`}
      style={{ backgroundColor: c.bg, color: c.text, borderColor: c.border }}
      data-testid={`status-badge-${status}`}
    >
      {dot && <span className="w-1.5 h-1.5 rounded-full" style={{ backgroundColor: c.text }} />}
      {c.label}
    </span>
  );
}
